<template>
    <LayoutDashboard title="Grupos de Permissões">
            <v-card outlined>
                <v-card-title>
                    <v-btn color="primary" @click="cadastrarGrupoPermissao" outlined>Cadastrar</v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field outlined dense v-model="search" append-icon="search" label="Pesquisar" single-line hide-details>
                    </v-text-field>
                </v-card-title>
                <v-card-text>
                    <v-data-table :headers="headers" :items="getGruposPermissoes" :search="search">
                        <template v-slot:item.action="{ item }">
                            <v-btn color="primary" outlined small @click="visualizarGrupoPermissao(item)">Visualizar</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            <ModalCadastroGrupoPermissao />
    </LayoutDashboard>
</template>

<script>
    import ModalCadastroGrupoPermissao from "@/pages/perfil/grupoPermissao/ModalCadastro"
    import { mapGetters, mapActions } from "vuex"

    export default {
        components: {
            ModalCadastroGrupoPermissao
        },
        data() {
            return {
                search: '',
                headers: [
                    { text: '#', value: 'id', sortable: false },
                    { text: 'Nome', align: 'left', sortable: false, value: 'nome'},
                    { text: 'Ações', value: 'action', sortable: false }
                ],
                funcionarios: [],
            }
        },
        computed: {
            ...mapGetters([
                'getGruposPermissoes'
            ])
        },
        methods: {
            ...mapActions([
                'listarGrupoPermissao',
                'visualizarGrupoPermissao',
                'cadastrarGrupoPermissao',
            ])
        },
        created() {
            this.listarGrupoPermissao()
        }
    }
</script>